import request from '../libs/request';

export default {
  //通用业务接口：账号管理 - 双重认证管理
  //0:关闭 1:开启 2:删除信任设备
  twoFAManager(params, errHandler = { hasCatchHandle: false, hasErrorHandle: false }) {
    return request.post('/ccfauth/public/user/v2/account/twofactor/manager', params, errHandler);
  },
  //通用业务接口：账号管理 - 双重认证 - 发送验证码
  //0:关闭 1:开启
  twoFAVeriCode(params) {
    return request.post('/ccfauth/public/user/v1/account/towfactor/verifycode', params, { hasCatchHandle: false, hasErrorHandle: false });
  },
  //用户管理 - 查询双重认证信息
  //查询类型：0:全部 1:开关 2:信任列表
  getTwoFAInfo(params) {
    return request.post('/ccfauth/public/user/v1/twofactor/get', params, { hasCatchHandle: false, hasErrorHandle: false });
  },
  //双重认证登录
  twoFALogin(params) {
    return request.post('/v1/login', params, { hasCatchHandle: false, hasErrorHandle: false });
  },
  //重新发送（双重认证）只用于登录流程里的验证码重新发送
  twoFACodeResend(params) {
    return request.post('/ccfauth/public/user/v1/resend', params, { hasCatchHandle: false, hasErrorHandle: false });
  },
  //登录二次认证(双重认证)只用于登录流程里的验证码校验
  twoFACodeVerify(params) {
    return request.post('/ccfauth/public/user/v1/twofactor/verify', params, { hasCatchHandle: false, hasErrorHandle: false });
  }
};